import React, {FC, useCallback} from "react";
import {Card, Col, Form, Row} from "react-bootstrap";
import {Field, useFormikContext} from "formik";
import {FormikRowInput, FormikRowCheckbox, FormikAsyncSelect} from "@components/panel/formik";
import ConsumerRefService from "@api/consumer/consumerRefService";

export enum ConditionType {
    All = 'all',
    One = 'one'
}

export interface GoalFormValues {
    name: string;
    description: string;
    isActive: boolean;
    hidden: boolean;
    order: number;
    conditionType: ConditionType;
    groupIds: string[];
}

interface GoalBaseInfoBlockProps {
    editForm?: boolean;
}

const GoalBaseInfoBlock: FC<GoalBaseInfoBlockProps> = ({editForm}) => {
    const {values, setFieldValue, errors} = useFormikContext<GoalFormValues>();

    const searchGoalGroups = useCallback((text: string) => {
        const api = new ConsumerRefService();
        return api.searchGoalGroup(text).then(res => {
            if (res.success) {
                return res.data.map(group => ({
                    value: group.id,
                    label: group.name
                }));
            }
            return [];
        });
    }, []);

    return (
        <Card className="mb-3">
            <Card.Header as="h6" className="bg-body-tertiary">Основное</Card.Header>
            <Card.Body>
                <Field
                    label="Название"
                    name="name"
                    component={FormikRowInput}
                />

                <Form.Group as={Row} className="mb-3">
                    <Form.Label column sm={3}>Описание</Form.Label>
                    <Col sm={9}>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            value={values.description}
                            onChange={e => setFieldValue('description', e.target.value)}
                            isInvalid={Boolean(errors.description)}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.description}
                        </Form.Control.Feedback>
                    </Col>
                </Form.Group>

                <Field
                    label="Скрыто"
                    name="hidden"
                    type="switch"
                    id="goal-hidden"
                    component={FormikRowCheckbox}
                />

                <Field
                    label="Группы"
                    name="groupIds"
                    isMulti
                    loadOptions={searchGoalGroups}
                    row
                    component={FormikAsyncSelect}
                />

                {editForm && (
                    <>
                        <Field
                            label="Активно"
                            name="isActive"
                            type="switch"
                            id="goal-active"
                            component={FormikRowCheckbox}
                        />

                        <Field
                            label="Порядковый номер"
                            name="order"
                            type="number"
                            component={FormikRowInput}
                        />

                        <Form.Group as={Row} className="mb-3">
                            <Form.Label column sm={3}>Условия</Form.Label>
                            <Col sm={9}>
                                <Form.Check
                                    type="radio"
                                    name="conditionType"
                                    id="condition-one"
                                    label="Хотя бы одно"
                                    checked={values.conditionType === ConditionType.One}
                                    onChange={() => setFieldValue('conditionType', ConditionType.One)}
                                />
                                <Form.Check
                                    type="radio"
                                    name="conditionType"
                                    id="condition-all"
                                    label="Все"
                                    checked={values.conditionType === ConditionType.All}
                                    onChange={() => setFieldValue('conditionType', ConditionType.All)}
                                />
                            </Col>
                        </Form.Group>
                    </>
                )}
            </Card.Body>
        </Card>
    );
};

export default GoalBaseInfoBlock;
